var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _path134, _path135, _path136, _path137, _path138;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadcocoLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1557.8 321.14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#gu)}.cls-2{fill:none}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0}.cls-6{clip-path:url(#gt)}.cls-7{clip-path:url(#bn)}.cls-8{clip-path:url(#by)}.cls-9{clip-path:url(#cm)}.cls-10{clip-path:url(#ag)}.cls-11{clip-path:url(#v)}.cls-12{clip-path:url(#ar)}.cls-13{clip-path:url(#bc)}.cls-14{clip-path:url(#k)}.cls-15{clip-path:url(#aq)}.cls-16{clip-path:url(#ah)}.cls-17{clip-path:url(#cl)}.cls-18{clip-path:url(#ch)}.cls-19{clip-path:url(#ce)}.cls-20{clip-path:url(#cf)}.cls-21{clip-path:url(#cg)}.cls-22{clip-path:url(#cd)}.cls-23{clip-path:url(#bi)}.cls-24{clip-path:url(#bh)}.cls-25{clip-path:url(#bm)}.cls-26{clip-path:url(#bk)}.cls-27{clip-path:url(#bl)}.cls-28{clip-path:url(#bf)}.cls-29{clip-path:url(#bj)}.cls-30{clip-path:url(#bg)}.cls-31{clip-path:url(#be)}.cls-32{clip-path:url(#bd)}.cls-33{clip-path:url(#q)}.cls-34{clip-path:url(#m)}.cls-35{clip-path:url(#o)}.cls-36{clip-path:url(#t)}.cls-37{clip-path:url(#r)}.cls-38{clip-path:url(#p)}.cls-39{clip-path:url(#u)}.cls-40{clip-path:url(#n)}.cls-41{clip-path:url(#s)}.cls-42{clip-path:url(#b)}.cls-43{clip-path:url(#l)}.cls-44{clip-path:url(#cb)}.cls-45{clip-path:url(#ca)}.cls-46{clip-path:url(#cc)}.cls-47{clip-path:url(#bz)}.cls-48{clip-path:url(#bt)}.cls-49{clip-path:url(#bs)}.cls-50{clip-path:url(#br)}.cls-51{clip-path:url(#bq)}.cls-52{clip-path:url(#bo)}.cls-53{clip-path:url(#bu)}.cls-54{clip-path:url(#bv)}.cls-55{clip-path:url(#bx)}.cls-56{clip-path:url(#bp)}.cls-57{clip-path:url(#bw)}.cls-58{clip-path:url(#e)}.cls-59{clip-path:url(#a)}.cls-60{clip-path:url(#g)}.cls-61{clip-path:url(#f)}.cls-62{clip-path:url(#i)}.cls-63{clip-path:url(#d)}.cls-64{clip-path:url(#j)}.cls-65{clip-path:url(#h)}.cls-66{clip-path:url(#c)}.cls-67{clip-path:url(#ay)}.cls-68{clip-path:url(#ax)}.cls-69{clip-path:url(#bb)}.cls-70{clip-path:url(#ba)}.cls-71{clip-path:url(#az)}.cls-72{clip-path:url(#aw)}.cls-73{clip-path:url(#av)}.cls-74{clip-path:url(#au)}.cls-75{clip-path:url(#at)}.cls-76{clip-path:url(#w)}.cls-77{clip-path:url(#ap)}.cls-78{clip-path:url(#am)}.cls-79{clip-path:url(#ao)}.cls-80{clip-path:url(#ai)}.cls-81{clip-path:url(#aj)}.cls-82{clip-path:url(#ac)}.cls-83{clip-path:url(#as)}.cls-84{clip-path:url(#al)}.cls-85{clip-path:url(#an)}.cls-86{clip-path:url(#ak)}.cls-87{clip-path:url(#af)}.cls-88{clip-path:url(#aa)}.cls-89{clip-path:url(#ad)}.cls-90{clip-path:url(#x)}.cls-91{clip-path:url(#ae)}.cls-92{clip-path:url(#y)}.cls-93{clip-path:url(#ab)}.cls-94{clip-path:url(#z)}.cls-95{clip-path:url(#fa)}.cls-96{clip-path:url(#fl)}.cls-97{clip-path:url(#fw)}.cls-98{clip-path:url(#gs)}.cls-99{clip-path:url(#ep)}.cls-100{clip-path:url(#dt)}.cls-101{clip-path:url(#ee)}.cls-102{clip-path:url(#cx)}.cls-103{clip-path:url(#gh)}.cls-104{clip-path:url(#di)}.cls-3{fill:#f9bfc0}.cls-4{fill:#2e6e58}.cls-5{fill:#fff}.cls-105{clip-path:url(#ev)}.cls-106{clip-path:url(#el)}.cls-107{clip-path:url(#eh)}.cls-108{clip-path:url(#ek)}.cls-109{clip-path:url(#eg)}.cls-110{clip-path:url(#et)}.cls-111{clip-path:url(#ex)}.cls-112{clip-path:url(#er)}.cls-113{clip-path:url(#ey)}.cls-114{clip-path:url(#eu)}.cls-115{clip-path:url(#ew)}.cls-116{clip-path:url(#es)}.cls-117{clip-path:url(#eq)}.cls-118{clip-path:url(#ez)}.cls-119{clip-path:url(#en)}.cls-120{clip-path:url(#em)}.cls-121{clip-path:url(#ei)}.cls-122{clip-path:url(#ej)}.cls-123{clip-path:url(#ef)}.cls-124{clip-path:url(#eo)}.cls-125{clip-path:url(#dg)}.cls-126{clip-path:url(#cz)}.cls-127{clip-path:url(#dh)}.cls-128{clip-path:url(#cn)}.cls-129{clip-path:url(#co)}.cls-130{clip-path:url(#cv)}.cls-131{clip-path:url(#cw)}.cls-132{clip-path:url(#cs)}.cls-133{clip-path:url(#cu)}.cls-134{clip-path:url(#cq)}.cls-135{clip-path:url(#cr)}.cls-136{clip-path:url(#cp)}.cls-137{clip-path:url(#ct)}.cls-138{clip-path:url(#dd)}.cls-139{clip-path:url(#de)}.cls-140{clip-path:url(#db)}.cls-141{clip-path:url(#da)}.cls-142{clip-path:url(#cy)}.cls-143{clip-path:url(#df)}.cls-144{clip-path:url(#dc)}.cls-145{clip-path:url(#gd)}.cls-146{clip-path:url(#ge)}.cls-147{clip-path:url(#gf)}.cls-148{clip-path:url(#gg)}.cls-149{clip-path:url(#gb)}.cls-150{clip-path:url(#gc)}.cls-151{clip-path:url(#ga)}.cls-152{clip-path:url(#fz)}.cls-153{clip-path:url(#fy)}.cls-154{clip-path:url(#fx)}.cls-155{clip-path:url(#gm)}.cls-156{clip-path:url(#gr)}.cls-157{clip-path:url(#gp)}.cls-158{clip-path:url(#go)}.cls-159{clip-path:url(#gk)}.cls-160{clip-path:url(#gi)}.cls-161{clip-path:url(#gn)}.cls-162{clip-path:url(#gq)}.cls-163{clip-path:url(#gj)}.cls-164{clip-path:url(#gl)}.cls-165{clip-path:url(#ec)}.cls-166{clip-path:url(#ed)}.cls-167{clip-path:url(#dx)}.cls-168{clip-path:url(#dr)}.cls-169{clip-path:url(#dq)}.cls-170{clip-path:url(#dk)}.cls-171{clip-path:url(#do)}.cls-172{clip-path:url(#dj)}.cls-173{clip-path:url(#ds)}.cls-174{clip-path:url(#dl)}.cls-175{clip-path:url(#dm)}.cls-176{clip-path:url(#dn)}.cls-177{clip-path:url(#dp)}.cls-178{clip-path:url(#fe)}.cls-179{clip-path:url(#fc)}.cls-180{clip-path:url(#ff)}.cls-181{clip-path:url(#fi)}.cls-182{clip-path:url(#fd)}.cls-183{clip-path:url(#fk)}.cls-184{clip-path:url(#fh)}.cls-185{clip-path:url(#fg)}.cls-186{clip-path:url(#fb)}.cls-187{clip-path:url(#fj)}.cls-188{clip-path:url(#fm)}.cls-189{clip-path:url(#ft)}.cls-190{clip-path:url(#fp)}.cls-191{clip-path:url(#fq)}.cls-192{clip-path:url(#fv)}.cls-193{clip-path:url(#fu)}.cls-194{clip-path:url(#fs)}.cls-195{clip-path:url(#fr)}.cls-196{clip-path:url(#fo)}.cls-197{clip-path:url(#fn)}.cls-198{clip-path:url(#dz)}.cls-199{clip-path:url(#dy)}.cls-200{clip-path:url(#dw)}.cls-201{clip-path:url(#eb)}.cls-202{clip-path:url(#ea)}.cls-203{clip-path:url(#dv)}.cls-204{clip-path:url(#du)}.cls-205{clip-path:url(#cj)}.cls-206{clip-path:url(#ck)}.cls-207{clip-path:url(#ci)}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "gu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ep"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "di"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "go"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gn"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ge"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ga"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ft"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fn"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ez"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ey"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ex"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ew"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ev"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "et"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "er"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "em"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "el"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ek"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ej"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "du"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ds"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "do"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dn"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1172.5,125.04c.1,1.2.2,2.3.2,3.5,0,33.4-55.2,60.4-123.3,60.4-15.5,0-30.4-1.4-44.1-4-16.8-3.1-31.8-8-44.1-14.2-21.7-10.9-35.1-25.8-35.1-42.2,0-1.2.1-2.3.2-3.5-24.4,68.8-30.7,192.5,123.1,192.5h.1c153.8,0,147.5-123.7,123-192.5h0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1120.9,307.64c19.7-8,35.2-20,46.4-35.9,13.9-19.6,20.8-44.6,20.6-74.3-.1-23.3-4.9-49.3-13.4-73.2,0-.1-.1-.1-.1-.2-2.5-18.5-21-35.3-51-46.2l12.1-68.5v-.3c.1-.8,0-1.9-.9-3.1-1.7-2.4-6-4.5-11.1-5.4s-9.9-.4-12.3,1.3c-1.3.9-1.8,2-1.9,2.8h0l-11.7,66.1c-15.3-3.2-31.6-4.8-48.4-4.8s-33,1.6-48.3,4.8l-11.6-66v-.1c-.1-.8-.6-1.9-1.9-2.8-2.4-1.7-7.1-2.2-12.3-1.3-5.2.9-9.4,3-11.1,5.4-.9,1.2-.9,2.3-.8,3.1v.2h0l12.1,68.6c-30.3,11-48.8,27.9-51.2,46.6-8.4,23.9-13.1,49.8-13.3,73-.2,29.7,6.8,54.7,20.6,74.3,22.4,31.8,62.1,47.9,117.8,47.9h.1c28.1,0,51.9-4,71.6-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m160.1,149.84c12.1-11.3,27.6-18,40.2-28.9,2.1-.4,4.2-.8,6.7-.8,8.4,0,17.6,3.3,23.4,9.6,7.1,36.8,19.7,105.4,38.1,138,1.3,13.8-16.3,13.8-25.1,13.8-6.3,0-11.7-1.3-14.6-7.5-12.5-30.5-25.9-74.5-31.8-107.1-.8-.8-1.7-1.7-2.9-1.7-2.1,0-5,3.3-7.1,4.6-16.3,21.8-32.6,45.6-45.6,69.4-3.3,6.7-6.7,14.6-14.6,17.1-3.8,1.3-7.5,2.1-11.7,2.1-2.9,0-8.4-.8-10.9-3.3-4.6-5-24.3-58.6-27.2-68.2-1.7-5-1.3-10.5-6.3-13.8-11.7,18-21.3,37.2-29.7,57.3-2.5,5.4-9.2,25.1-11.7,28.9-2.1,3.3-8.8,3.8-12.6,3.8h-3.3c-5.4-2.1-9.6-7.5-13.4-12.1,2.1-16.3,10.5-31,16.7-46,8.8-20.5,21.3-38.9,31.8-58.6,3.3-6.7,6.7-13.4,9.2-20.1.8-2.9,1.7-6.7,2.9-9.2,2.9-6.3,10.9-11.7,17.6-11.7,15.9,0,22.6,25.1,24.7,37.6,2.1,13.4,12.1,44.8,18,57.3,14.9-15,23.3-35.4,39.2-50.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m521.9,261.34c.4,5.9-4.2,11.3-9.2,14.2-6.3,0-11.7,1.3-18,1.3-2.5,0-5.9-.4-8.4-1.3-7.9-4.2-27.2-47.3-39.7-56.5-13-1.3-25.5-1.7-38.5-1.7-8.8,0-17.2.4-25.9.4-7.5,12.6-15.5,24.7-22.6,37.2-3.3,6.3-6.3,15.5-10,20.9-3.3,5-11.7,12.1-18,12.1-8.8,0-17.1-11.7-18-20.1,7.1-17.1,17.1-32.6,24.7-49.8,12.1-29.3,28-56.9,39.3-86.6,5.9-14.2,13-32.6,31.4-32.6,2.1,0,4.6.8,6.7,1.3,10,.8,17.1.4,22.2,10.9,9.6,20.9,21.3,41.8,32.6,62.3,7.9,14.6,15.9,30.1,24.7,44.3,2.9,4.6,6.7,9.2,9.6,13.8,5.9,9.2,11.3,18.8,17.2,28.4v1.5h-.1Zm-128.4-79.5c5,2.5,13.8,2.9,19.2,2.9,8.8,0,17.6-.8,26.4-2.1-5.4-10.5-16.3-30.5-25.1-38.1-7.9,9.3-18.4,25.6-20.5,37.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m606.9,301.84c-5.9,2.5-11.7,6.3-18.4,6.3-28.4,0-22.2-51-22.2-69.4v-2.9c0-41,.4-53.1-2.1-94.1-.4-8.8-1.3-17.6-1.3-25.9,0-8.8.8-23,7.9-28.9,3.3-2.9,10.5-7.9,15.1-7.9s7.1,2.5,10.9,4.6c27.2,15.9,53.5,32.6,73.2,58.1,21.8,27.2,34.7,32.6,34.7,67.3,0,68.1-41.8,66-97.8,92.8m-5.9-154.3c0,28,2.5,26.7,2.5,55.2,0,6.7-.4,13.4-.4,20.1,0,22.6,1.3,15.9,2.1,38.5,30.9-6.3,60.7-24.2,60.7-53.9,0-36.8-34.3-56-64.4-75.7-.1,5-.5,10.4-.5,15.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m870,106.94c0,24.3-77.4,16.3-77.4,90.8,0,15.5,5.4,43.5,18.4,54,20.9,16.3,66.9,1.7,66.9,25.1,0,18.8-28.9,20.9-42.2,20.9-23.8,0-54-12.5-66.1-34.3-10.9-19.2-15.5-44.3-15.5-66.5,0-24.7,6.3-60.2,26.4-77,16.3-14.2,41.4-30.5,64-30.5,7.1,0,14.2,1.7,20.1,5.4,1.7,2.1,4.2,4.2,4.2,6.7.7,1.7,1.2,3.3,1.2,5.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1344.4,106.94c0,24.3-77.4,16.3-77.4,90.8,0,15.5,5.4,43.5,18.4,54,20.9,16.3,66.9,1.7,66.9,25.1,0,18.8-28.9,20.9-42.2,20.9-23.8,0-54-12.5-66.1-34.3-10.9-19.2-15.5-44.3-15.5-66.5,0-24.7,6.3-60.2,26.3-77,16.3-14.2,41.4-30.5,64-30.5,7.1,0,14.2,1.7,20.1,5.4,1.7,2.1,4.2,4.2,4.2,6.7.8,1.7,1.3,3.3,1.3,5.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1542.2,233.44c-13.8,23-49.8,51.5-77.4,51.5-2.1,0-4.2-.4-6.3-.8-41.8-7.9-62.7-39.3-62.7-80.7,0-18.4,3.8-45.2,15.5-59.8,16.7-20.9,49.4-41.4,77-41.4s41.8,2.5,58.6,25.9c8.8,12.1,10.9,28.9,10.9,43.5-.1,20-4.7,44.3-15.6,61.8m-96.6-76.9c-9.6,9.6-13,32.2-13,44.8,0,23.4,13,43.5,38.5,43.5,33.9,0,51.9-34.3,51.9-64.4,0-9.2-1.7-25.1-9.6-31.4-9.2-7.5-20.5-11.3-32.2-11.3-11.3,0-28.1,11.7-35.6,18.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1188,197.54c.2,29.7-6.8,54.7-20.6,74.3-22.4,31.8-62.1,47.9-117.8,47.9h0c1.1-.1,2-1,2-2.1,0-1.2-1-2.1-2.1-2.1h.1c54.3,0,92.8-15.5,114.4-46.1,13.3-18.8,20-43,19.8-71.8-.1-19.5-3.5-41-9.7-61.5.6-2.5.9-5,.9-7.5,0-1.3-.1-2.5-.2-3.8,0-.2-.1-.5-.1-.7,0,.1.1.1.1.2,8.3,23.9,13,49.9,13.2,73.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1174.6,124.74c.1,1.2.2,2.5.2,3.8,0,2.5-.3,5-.9,7.5-1-3.5-2.2-6.9-3.4-10.3-.1-.2-.1-.3-.1-.5-.1-1,.5-1.9,1.4-2.3,1-.4,2.2.1,2.6,1.1.2.3.2.5.2.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1174.5,124.14c-.5-1-1.6-1.5-2.6-1.1-1,.3-1.5,1.3-1.4,2.3h-.1c-2-17-19.3-32.6-47.6-43.1l.8-4.3c29.9,10.9,48.4,27.6,50.9,46.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1170.6,125.74c1.2,3.4,2.3,6.8,3.4,10.3-3.3,14.1-16,27.1-36.4,37.2-23.6,11.6-54.9,17.9-88.1,17.9-15.3,0-30.3-1.4-44.5-4-16.7-3.1-32.1-8.1-44.7-14.4-19.7-9.9-32-22.6-35.3-36.4,1.1-3.5,2.2-7,3.4-10.4v-.1c0-.1.1-.2.1-.3v-.2c-.1,1-.2,2.1-.2,3.2,0,15,12,29.3,33.9,40.3,12.2,6.1,27.3,11,43.6,14,13.9,2.6,28.6,3.9,43.7,3.9,66.8,0,121.2-26.2,121.2-58.3,0-1.1-.1-2.2-.2-3.2h.1c-.1.2-.1.3,0,.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.8,99.34c20.7,7.5,32,17.9,32,29.2,0,22.4-45,40-102.4,40s-102.4-17.6-102.4-40c0-11.4,11.4-21.8,32.1-29.3l.4,2.1c-18.7,6.9-30.4,16.5-30.4,27.1,0,20.9,44.9,37.9,100.2,37.9s100.2-17,100.2-37.9c0-10.6-11.6-20.2-30.3-27.1l.6-2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.4,101.44c18.7,6.9,30.3,16.5,30.3,27.1,0,20.9-44.9,37.9-100.2,37.9s-100.2-17-100.2-37.9c0-10.7,11.6-20.3,30.4-27.1l.4,2.1c-18.2,6.7-28.6,15.8-28.6,25,0,19.4,44.9,35.7,98.1,35.7s98.1-16.4,98.1-35.7c0-9.2-10.3-18.2-28.5-25l.2-2.1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119,103.54c18.2,6.7,28.5,15.8,28.5,25,0,19.4-44.9,35.7-98.1,35.7s-98.1-16.4-98.1-35.7c0-9.2,10.4-18.3,28.6-25l5.4,30.6v.3c0,.1.1.2.1.3s0,.1.1.1c0,0,0,.1.1.1.2.4.6.7,1.1.9.1,0,.2.1.3.1,3.5,1,7.7,1.5,12,1.5s8.2-.5,11.7-1.4q.1,0,.2-.1h0q.1,0,.2-.1c.2-.1.4-.2.6-.4l.1-.1.1-.1s.1-.1.1-.2c.1-.1.1-.2.2-.3q0-.1.1-.2v-.6h0v-.3h0v-.1l-6.5-36.9c13.5-2.5,28.6-3.8,43.8-3.8s30.4,1.3,43.9,3.9l-6.5,36.9v1q0,.1.1.2s0,.1.1.1c0,.1.1.1.1.2l.1.1c.1.2.3.3.5.4l.1.1c.1,0,.1.1.2.1,0,0,.1,0,.1.1.1,0,.2.1.2.1h0c3.5.9,7.5,1.4,11.7,1.4s8.4-.5,12-1.5c.1,0,.2,0,.3-.1.2-.1.4-.2.6-.4.1-.1.2-.1.2-.2h0l.1-.1.1-.1.1-.1c.1-.1.1-.3.2-.4v-.3l5.2-30.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1134.8,5.94c.9,1.2,1,2.3.9,3.1.1-1.1-.7-2.1-1.8-2.3-1.2-.2-2.3.6-2.5,1.7h0c-.4-.8-3.2-2.8-8.4-3.7-5.2-.9-8.5,0-9.2.6h0c.2-1.2-.6-2.3-1.7-2.5-1.2-.2-2.3.6-2.5,1.7.1-.8.6-1.9,1.9-2.8,2.4-1.7,7.1-2.2,12.3-1.3,5.1,1,9.3,3.1,11,5.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1133.9,6.84c1.1.2,1.8,1.2,1.8,2.3v.4c-.2.7-.6,1.8-1.9,2.7-.8.6-1.9,1-3.1,1.3l.9-4.9c.1-1.3,1.2-2,2.3-1.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.6,9.44l-12.1,68.5c-.6-.2-1.1-.4-1.7-.6-1.1-.4-2.3.2-2.7,1.3,0,.1-.1.2-.1.3l11.6-65.6c1.3-.3,2.3-.7,3.2-1.3,1.2-.8,1.7-1.9,1.8-2.6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1131.5,8.54l-.9,4.9c-1.2.3-2.7.4-4.2.4s-3.2-.1-4.9-.4c-3.4-.6-6.4-1.7-8.6-3.1l.9-4.9h0c.4.8,3.2,2.8,8.4,3.8,5.2.9,8.5-.1,9.3-.7h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1130.6,13.34l-11.6,65.6v.1l-3.8,21.3-5.6,31.7c-2.9.7-6.2,1-9.6,1-3,0-6-.3-8.7-.8l6.5-36.9,3.8-21.6,11.2-63.5c2.1,1.4,5.2,2.5,8.6,3.1,1.7.3,3.4.4,4.9.4,1.6.1,3-.1,4.3-.4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1123.5,77.94l-.8,4.3c-.8-.3-1.6-.6-2.4-.8-1-.3-1.6-1.3-1.4-2.3v-.1c0-.1,0-.2.1-.3.4-1.1,1.6-1.7,2.7-1.3.7.1,1.3.3,1.8.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1122.8,82.24l-3,17.1c-.6-.2-1.1-.4-1.7-.6-1.1-.4-2.3.2-2.7,1.3,0,.1-.1.2-.1.4h0l3.8-21.3c-.1,1,.4,2,1.4,2.3.7.2,1.5.5,2.3.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.8,99.34l-.4,2.1c-.7-.2-1.3-.5-2-.7l-.4,2.1c-.1,0-.2-.1-.3-.1-1-.3-1.6-1.4-1.4-2.4,0-.1,0-.2.1-.4.4-1.1,1.6-1.7,2.7-1.3.5.2,1.1.5,1.7.7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.4,101.44l-.4,2.1c-.7-.2-1.3-.5-2-.7l.4-2.1c.7.2,1.3.4,2,.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119,103.54l-5.4,30.6c0-.3,0-.6-.1-.9-.2-.8-.9-1.4-1.7-1.5l5.1-28.9c.8.2,1.5.5,2.1.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1116.7,102.74c.1,0,.2.1.3.1l-5.1,28.9c-.3-.1-.6,0-.9,0-.4.1-.8.2-1.3.3l5.6-31.7h0c-.2,1,.4,2,1.4,2.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1113,227.94c1.2.1,2,1.2,1.9,2.4-.1,1.2-1.2,2-2.4,1.9-.1,0-9-1-19.3.9-.1-.1-.1-.3-.2-.4-1-1.9-3.1-2.9-5.2-2.4-5.6,1.3-10.5,3.3-14.6,5.9,4.8-3.2,10.8-5.6,17.6-7,11.6-2.4,21.7-1.3,22.2-1.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1112,2.94c1.2.2,1.9,1.3,1.7,2.5l-.9,4.9c-1.1-.7-1.9-1.5-2.5-2.3-.9-1.3-1-2.5-.8-3.3h0c.3-1.2,1.3-2,2.5-1.8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1113.6,133.24c.1.3.1.6.1.9v.3c0,.1-.1.3-.2.4,0,0,0,.1-.1.1,0,0,0,.1-.1.1l-.1.1h0l-.2.2c-.2.1-.4.3-.6.4q-.1,0-.2.1h-.1c-.2,0-.3.1-.5.1h-.4c-.9-.1-1.5-.8-1.7-1.6.7-.1,1.4-.3,2.1-.5l.4-2.1c.7.1,1.3.7,1.6,1.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1113.3,134.94l.1-.1s0,.1-.1.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1113.1,135.24l.1-.1-.1.1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1113.1,135.24l-.2.2c.1,0,.1-.1.2-.2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1112.9,10.24l-11.2,63.5h0c.3-1.2-.5-2.3-1.6-2.5-.7-.2-1.4-.3-2.2-.5l11.7-66.1c-.1.8-.1,2,.8,3.3.5.8,1.4,1.6,2.5,2.3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1112.1,135.84q.1,0,.2-.1c-.1.1-.2.2-.2.1-.1.1,0,.1,0,0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.9,131.74l-.4,2.1c-.7.2-1.4.4-2.1.5-.1-.3-.1-.6,0-.9l.2-1.4c.4-.1.9-.2,1.3-.3.4-.1.7-.1,1,0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.5,135.94c.2,0,.3,0,.5-.1-3.5,1-7.7,1.5-12,1.5s-8.2-.5-11.7-1.4h.6c1,0,1.8-.7,2.1-1.7,2.7.5,5.8.8,9,.8,3.4,0,6.6-.3,9.4-.9.2.8.8,1.4,1.7,1.6.2.2.3.2.4.2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1109.7,132.14l-.2,1.4c-.1.3,0,.6,0,.9-2.8.6-6,.9-9.4.9s-6.3-.3-9-.8v-.1l.4-2c2.7.5,5.6.8,8.7.8,3.3-.1,6.6-.5,9.5-1.1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1100.1,71.24c1.1.3,1.9,1.4,1.6,2.5-.2,1-1.1,1.7-2.1,1.7-.2,0-.3,0-.5-.1-.7-.1-1.3-.3-2-.4l.7-4.2c.8.2,1.5.3,2.3.5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1101.7,73.74l-3.8,21.6h0c.2-1.2-.5-2.3-1.7-2.5-.7-.1-1.4-.3-2.1-.4l3.1-17.5c.7.1,1.3.3,2,.4h.5c.9.1,1.8-.6,2-1.6h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1096.2,92.84c1.1.2,1.9,1.4,1.7,2.5-.2,1-1.1,1.7-2.1,1.7h-.4l.4-2.1h0c-.7-.1-1.4-.3-2.1-.4l.4-2.1c.7.2,1.4.3,2.1.4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1097.9,70.74l-.7,4.2c-15.1-3.2-31.1-4.7-47.7-4.7s-32.5,1.6-47.6,4.7l-.7-4.2c15.3-3.2,31.6-4.8,48.3-4.8s33,1.6,48.4,4.8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1097.9,95.34l-6.5,36.9c-.7-.1-1.3-.3-1.9-.4h-.2l6.1-34.8h.4c1,.1,1.9-.6,2.1-1.7h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1095.8,94.94l-.4,2.1h-.1c-.7-.1-1.4-.3-2-.4l.4-2.1c.7.2,1.4.3,2.1.4h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1095.4,97.04l-6.1,34.8c-1.1-.2-2.1.5-2.4,1.6v.2-.1l6.5-36.9c.6.2,1.3.3,2,.4h0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1093.2,233.14c1.6,3.2,2.4,7,2.4,11,0,10.8-6.4,19.7-14.4,19.7s-14.4-8.8-14.4-19.7v-1.1c.1-1.3.7-2.6,1.6-3.4,1.4-1.2,2.9-2.3,4.4-3.2-1.5,1-2.9,2.1-4.2,3.3-.9.8-.9,2.1-.1,3l.4.4v1.1c0,9.7,5.5,17.5,12.2,17.5s12.2-7.9,12.2-17.5c0-3.9-.9-7.5-2.4-10.4l-.1-.1c.2,0,.4-.1.6-.1.7-.3,1.2-.4,1.8-.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1094.1,92.44l-.4,2.1c-13.3-2.5-28.4-3.9-44.3-3.9s-30.8,1.4-44.2,3.9l-.4-2.1c13.7-2.5,29.1-3.9,44.5-3.9s31,1.4,44.8,3.9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1093.7,94.54l-.4,2.1c-13.5-2.5-28.6-3.9-43.9-3.9s-30.3,1.3-43.8,3.8l-.4-2.1c13.3-2.5,28.3-3.9,44.2-3.9,15.9.1,30.9,1.5,44.3,4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1093,232.74c.1.1.1.3.2.4-.5.1-1.1.2-1.6.3-.2,0-.4.1-.6.1-.6-.9-1.6-1.4-2.7-1.1-4.1,1-8.4,2.5-12.3,4.6,0,0,0-.1-.1-.1-.6-.9-1.8-1.2-2.8-.7,4.2-2.6,9.1-4.6,14.6-5.9,2.2-.5,4.3.5,5.3,2.4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1091.1,233.64c1.5,2.9,2.4,6.5,2.4,10.4,0,9.7-5.5,17.5-12.2,17.5s-12.2-7.9-12.2-17.5v-1.1c.3.2.7.3,1.1.3.3,0,.7-.1,1-.2v1c0,8.3,4.6,15.4,10.1,15.4s10.1-7.1,10.1-15.4c0-3.4-.7-6.7-2.1-9.4-.1-.2-.2-.2-.4-.2-5.1,1.2-9.6,3-13.4,5.4h0l.1-.1c4.3-2.8,9.5-4.9,15.5-6.3-.1.1,0,.2,0,.2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1091.4,132.34l-.4,2v.1c-.7-.1-1.4-.3-2.1-.5l.4-2.1h.2c.6.2,1.2.3,1.9.5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1089.2,234.64c1.4,2.7,2.1,6,2.1,9.4,0,8.3-4.6,15.4-10.1,15.4s-10.1-7.1-10.1-15.4v-1c.2-.1.3-.2.5-.3,1.1-1,2.3-2,3.7-2.9h0c3.8-2.3,8.3-4.2,13.4-5.4.3,0,.4.1.5.2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1091,134.44c-.2,1-1.1,1.7-2.1,1.7h-.6c-.1,0-.2,0-.2-.1,0,0-.1,0-.1-.1-.1,0-.1-.1-.2-.1l-.1-.1c-.2-.1-.3-.3-.5-.4l-.1-.1c0-.1-.1-.1-.1-.2,0,0,0-.1-.1-.1,0-.1-.1-.1-.1-.2v-1.1c.3-1.1,1.3-1.8,2.4-1.6l-.4,2.1c.8,0,1.5.1,2.2.3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1088.3,232.44c1.1-.3,2.2.2,2.7,1.1-6.1,1.3-11.3,3.4-15.5,6.3,0,0-.1,0-.1.1h0c.9-.6,1.2-1.9.6-2.8,3.9-2.3,8.2-3.8,12.3-4.7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1088 135.84s0.1 0 0.1 0.1l-0.1-0.1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1087.7,135.64l.1.1q-.1,0-.1-.1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1087.1,135.14l.1.1s0-.1-.1-.1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1087,134.84s0,.1.1.1l-.1-.1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1086.8,134.44v.1q.1,0,0-.1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1079.2,282.34c1.7,2.8,2,5.5,1,7.4-.7,1.5-2,2.6-3.9,3.2v-.5c0-.8-.1-1.8-.6-2.8-.1-.3-.3-.6-.5-.9.6-.2,1-.5,1.2-.9,0,0,0-.1.1-.1.1-.2.2-1.3-.9-3.2-3-5-12.3-12.4-25.8-12.4h-.1c-13.5,0-22.9,7.4-25.8,12.4-1.1,1.9-1.1,3-.9,3.2v.1c.9,2,7.3,1.5,13.4,1.1,2.1-.2,4.2-.3,6.5-.4-.5.8-.7,1.7-.7,2.6,0,.6.1,1.1.3,1.6-2,.1-3.9.2-5.8.4-2.9.2-5.6.4-8,.4-4.7,0-8.1-.8-9.6-3.8-1-1.9-.6-4.5,1-7.4,5.7-9.5,19.1-14.5,29.5-14.5h.1c13.7-.1,25.2,7.2,29.5,14.5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1075.5,284.44c1.1,1.9,1.1,3,.9,3.2,0,0,0,.1-.1.1-.2.4-.6.7-1.2.9-1.5-2.1-4.1-2.6-5.1-2.8-3.7-.7-7.4-.6-10.8-.5-1.7.1-3.4.2-5.1.2-1.7.1-3.3.1-5,.2h-.7c-1.4,0-3.2.1-4.8,1.4-.4.3-.7.7-.9,1.1-2.3.1-4.4.3-6.5.4-6.1.4-12.5.9-13.4-1.1,0,0,0-.1-.1-.1-.1-.2-.2-1.3.9-3.2,3-5,12.3-12.4,25.8-12.4h.1c13.8.2,23.1,7.6,26,12.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1076.3,292.84c.2,2.9.3,6.4-.3,9.8-.2,1.2-.6,2.8-1.6,4.2-1.1,1.5-2.8,2.4-4.4,2.4h-.5c-.9-.1-1.8-.5-2.5-1.1-.6-.6-1-1.3-1.1-1.8-.6-1.6-.7-3.2-.8-4.6-.1-1.1-.1-2.1-.4-3-.1.2-.1.5-.1.8-.1.4-.1.9-.2,1.3-.4,1.7-1,2.9-2,3.8-1.5,1.4-3.8,1.7-5.4.6-.7-.5-1.7-1.4-2.1-3.4-.2-.9-.2-1.8-.2-2.6,0-.4,0-.8-.1-1.2-.1-.9-.3-1.6-.6-2-.4-.5-1.4-.7-2.7-.6-.4,0-.8.1-1.2.1-1.2.1-2.5.2-3.8,0-1-.2-1.8-.5-2.5-1.1-.5-.4-.9-1-1.1-1.6.6,0,1.3-.1,1.9-.1,1,0,1.8-.7,2-1.7v.1s.2,0,.4.1c.8.1,1.7.1,2.7,0,.5,0,1-.1,1.4-.1,2.6-.1,4.6.5,5.9,1.9,1,1.1,1.6,2.6,1.8,4.5,0,.5.1.9.1,1.4,0,.7.1,1.3.2,1.9.1.3.1.5.2.6.1,0,.2-.1.3-.1.3-.3.5-.8.7-1.6.1-.4.1-.7.2-1.1.1-.7.2-1.3.5-2.1.1-.5.6-1.8,1.9-2.6.5-.3,1.1-.4,1.7-.4.8,0,1.6.2,2.2.7.8.5,1.4,1.3,1.8,2.4.7,1.6.8,3.3.8,4.8.1,1.2.1,2.4.5,3.3.1.2.1.3.1.3.3,0,.8-.3,1-.7.5-.7.7-1.6.8-2.4.5-2.9.4-5.8.2-9.3,0-.4,0-.7-.1-1h0c.2,1.1,1.3,1.9,2.4,1.7.7-.2,1.4-.3,2-.5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1076.3,292.34v.5c-.6.2-1.3.3-2,.4-1.1.2-2.2-.6-2.4-1.7v-.1c-.2-1.2.6-2.2,1.8-2.4.6-.1,1.1-.2,1.5-.4.2.3.4.6.5.9.5,1,.5,2.1.6,2.8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1076,237.04c.6,1,.3,2.2-.6,2.8h0c-.3.2-.7.3-1,.3-.7,0-1.4-.3-1.8-1h0c.5-.4,1.1-.8,1.7-1.1h0s.1,0,.1-.1c.4-.3,1-.6,1.6-.9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1074.2,238.14h0c-.6.4-1.1.7-1.7,1.1-.6-1-.4-2.3.6-2.9h0c1-.5,2.2-.2,2.8.7l.1.1c-.6.2-1.2.5-1.8,1q0-.1,0,0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1075.4,239.84h0c-.1,0-.1.1,0,0q-.1,0,0,0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1075.3,239.94h0c-1.4.9-2.7,1.8-4,2.9-.1.1-.1.2-.1.3-.3.2-.7.2-1,.2-.4,0-.8-.1-1.1-.3h0c0-.7.3-1.4.9-1.8.8-.7,1.7-1.4,2.6-2h0c.4.6,1.1,1,1.8,1,.2-.1.6-.2.9-.3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1075.2,288.64c-.4.2-.9.3-1.5.4-1.2.2-2,1.3-1.8,2.4v.1h0c0-.1-.1-.2-.1-.3-.1-.3-.6-.8-2.5-1.2-3.3-.6-6.6-.6-9.8-.4-1.7.1-3.4.2-5.2.2-1.6.1-3.3.1-4.9.2h-.8c-1,0-1.6,0-2,.4h0c-.1.1-.1.2-.2.3v-.4c0-1.2-1-2.1-2.2-2.1-.5,0-.9,0-1.4.1.2-.4.5-.8.9-1.1,1.6-1.4,3.4-1.4,4.8-1.4h.7c1.7-.1,3.3-.2,5-.2,1.7-.1,3.4-.1,5.1-.2,3.4-.2,7.1-.2,10.8.5,1,.2,3.7.7,5.1,2.7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1073,236.24q.1,0,0,0c-.9.6-1.2,1.9-.6,2.9-.9.6-1.7,1.3-2.6,2-.5.4-.8,1.1-.9,1.8h0c-.2-.1-.3-.2-.4-.4-.8-.9-.7-2.2.1-3,1.4-1.1,2.9-2.2,4.4-3.3q0,.1,0,0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1075.3,239.94c-1.3.9-2.5,1.9-3.7,2.9-.1.1-.3.2-.5.3,0-.1,0-.2.1-.3,1.4-1.1,2.7-2.1,4.1-2.9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1058.6,250.74c.4.7.4,1.5,0,2.1l-7.1,12.3c-.4.7-1.1,1.1-1.9,1.1s-1.5-.4-1.8-1.1l-7.1-12.3c-.4-.7-.4-1.5,0-2.1.4-.7,1.1-1.1,1.8-1.1h14.2c.8.1,1.5.5,1.9,1.1m-8.9,9.1l3.4-5.9h-6.8l3.4,5.9Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1049.4,315.44c1.2,0,2.1,1,2.1,2.1s-.9,2.1-2,2.1l-.1-2.1v-2.1Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1049.4,317.54l.1,2.1h-.1c-55.7,0-95.4-16.1-117.8-47.9-13.8-19.6-20.8-44.6-20.6-74.2.1-23.2,4.8-49.1,13.3-73v.3c-.1,1.2-.2,2.4-.2,3.7,0,2.6.3,5.2.9,7.7-6.2,20.5-9.6,41.9-9.7,61.3-.2,28.8,6.5,52.9,19.8,71.8,21.6,30.6,60.1,46.1,114.4,46.1v2.1h-.1Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1046.4,290.44v.5h0c-.2.9-1,1.6-2,1.7-.7,0-1.3.1-1.9.1-.2-.5-.3-1.1-.3-1.6,0-.9.2-1.9.7-2.6.5,0,.9,0,1.4-.1,1.1-.1,2.1.8,2.1,2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1032.1,242.94v1.1c0,10.8-6.4,19.7-14.4,19.7s-14.3-8.8-14.3-19.7c0-4,.8-7.8,2.4-11,.5.1,1.1.2,1.6.3.2,0,.4.1.6.1l-.1.1c-1.5,2.9-2.4,6.5-2.4,10.4,0,9.7,5.5,17.5,12.2,17.5s12.2-7.9,12.2-17.5v-1.1c.2-.1.3-.2.4-.4.8-.9.7-2.2-.1-3-1.4-1.3-2.8-2.4-4.4-3.4,1.6,1,3.1,2.1,4.6,3.3,1,1.1,1.6,2.3,1.7,3.6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1030.2,239.64c.9.8.9,2.1.1,3l-.4.4h0c0-.7-.3-1.4-.9-1.8-1.4-1.2-2.9-2.3-4.5-3.2-4.4-2.7-9.2-4.4-13.9-5.6-1.1-.3-2.1.2-2.7,1.1-.2,0-.4-.1-.6-.1-.5-.1-1.1-.2-1.6-.3.1-.1.1-.3.2-.4,1-1.9,3.1-2.9,5.2-2.4,5.5,1.3,10.4,3.3,14.5,5.8.1,0,.1.1.1.1,1.7,1,3.2,2.2,4.5,3.4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1029.9,243.04v1.1c0,9.7-5.5,17.5-12.2,17.5s-12.2-7.9-12.2-17.5c0-3.9.9-7.5,2.4-10.4l.1-.1c6,1.3,11.2,3.4,15.5,6.2h.1c-3.8-2.3-8.3-4.1-13.3-5.3h-.1c-.1,0-.2.1-.3.2-1.4,2.7-2.2,6-2.2,9.4,0,8.3,4.6,15.4,10.1,15.4s10.1-7.1,10.1-15.4v-.9h0c.3.2.7.3,1,.3.3-.2.7-.3,1-.5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1029.9,243.04h0c-.3.2-.7.3-1.1.3-.3,0-.7-.1-1-.3,0-.1-.1-.2-.1-.3-1.3-1.1-2.7-2.1-4.2-3h-.1c-4.3-2.8-9.4-4.9-15.5-6.2.6-.9,1.6-1.4,2.7-1.1,4.7,1.1,9.5,2.9,13.9,5.6,1.6,1,3,2,4.5,3.2.6.4.9,1.1.9,1.8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1027.8,243.14v.9c0,8.3-4.6,15.4-10.1,15.4s-10.1-7.1-10.1-15.4c0-3.4.7-6.7,2.2-9.4.1-.1.2-.2.3-.2h.1c5.1,1.2,9.5,3,13.3,5.3h0c1.3.9,2.6,1.9,3.8,3,.2.2.3.3.5.4h0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1027.7,242.84c.1,0,.1.1.1.3-.2-.1-.3-.2-.4-.3-1.2-1.1-2.5-2.1-3.8-3,1.4.9,2.8,1.9,4.1,3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1025.7,236.14c-4.2-2.6-9-4.5-14.5-5.8-2.1-.5-4.2.5-5.2,2.4-.1.1-.1.3-.2.4-10.3-1.9-19.2-.9-19.3-.9-1.2.1-2.2-.7-2.4-1.9-.1-1.2.7-2.2,1.9-2.4.4,0,10.6-1.1,22.3,1.3,6.7,1.4,12.6,3.7,17.4,6.9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1012.2,133.64v.3h0v.6q0,.1-.1.2c0,.1-.1.2-.2.3,0,.1-.1.1-.1.2l-.1.1c0,.1-.1.1-.1.1-.2.2-.4.3-.6.4-.1,0-.1.1-.2.1h0c-.1,0-.2.1-.3.1h-.4c-1,0-1.9-.7-2.1-1.7.7-.1,1.4-.3,2.1-.5l-.4-2.1c1.1-.2,2.2.5,2.4,1.6.1.1.1.2.1.3h0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1012.2,133.64c0-.1,0-.2-.1-.2-.3-1.1-1.3-1.8-2.4-1.6l-6.1-34.8h0c.7-.1,1.4-.3,2.1-.4l6.5,37h0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1012.1,134.54v-.2c.1,0,0,.1,0,.2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1012.1,134.64q0-.1.1-.2c-.1.1-.1.2-.1.2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1011.9,135.04c.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1011.8,135.14c0-.1.1-.1.1-.2,0,.1,0,.2-.1.2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1011.7,135.34l.1-.1-.1.1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1011.6,135.44l.1-.1-.1.1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1011,135.84c.2-.1.4-.3.6-.4-.2.2-.4.3-.6.4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1010.8,135.94q.1,0,.2-.1-.1.1-.2.1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1010.8,135.94q-.1,0-.2.1c-3.5.9-7.5,1.4-11.7,1.4s-8.4-.5-12-1.5c.2,0,.3.1.5.1h.4c.9-.2,1.5-.8,1.7-1.6,2.8.6,6,.9,9.4.9,3.2,0,6.3-.3,9-.8.2,1,1.1,1.7,2.1,1.7h.4c.2-.2.3-.2.4-.3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1009.7,131.84l.4,2.1c-.7.2-1.4.3-2.1.5v-.1l-.4-2c.7-.1,1.3-.3,1.9-.4q.1-.1.2-.1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1003.6,97.04l6.1,34.8h-.2c-.6.2-1.3.3-1.9.4l-6.5-36.9c.3,1.2,1.3,1.9,2.5,1.7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1008,134.34v.1c-2.7.5-5.8.8-9,.8-3.4,0-6.6-.3-9.4-.9.1-.3.1-.6,0-.9l-.2-1.4c2.9.7,6.2,1,9.6,1,3,0,6-.3,8.7-.8l.3,2.1Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1001.1 95.44 6.5 36.9c-2.7 0.5-5.6 0.8-8.7 0.8-3.4 0-6.7-0.4-9.6-1l-5.6-31.7v-0.2l-3.7-21.2-11.6-65.6c1.3 0.3 2.7 0.4 4.2 0.4 1.6 0 3.3-0.2 4.9-0.4 3.4-0.6 6.4-1.7 8.6-3.1l11.2 63.2v0.3l3.8 21.4v0.1 0.1 0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1005.3,94.54l.4,2.1c-.7.1-1.4.3-2.1.4h0l-.4-2.1c.7-.1,1.4-.3,2.1-.4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1004.9,92.44l.4,2.1c-.7.1-1.4.3-2.1.4l.4,2.1c-1.1.2-2.2-.5-2.4-1.6v-.3c-.1-1.1.6-2.1,1.7-2.3.6-.1,1.3-.3,2-.4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1001.8,74.94l3.1,17.5c-.7.1-1.4.3-2.1.4-1.1.2-1.8,1.2-1.7,2.3l-3.8-21.4c.3,1.1,1.4,1.9,2.5,1.6.7-.1,1.4-.3,2-.4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1001.1,70.74l.7,4.2c-.7.1-1.3.3-2,.4-1.1.2-2.3-.5-2.5-1.6v-.3c-.1-1.1.6-2.1,1.7-2.3.6-.1,1.4-.3,2.1-.4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m989.4,4.74l11.6,66c-.7.1-1.5.3-2.2.5-1.1.2-1.8,1.2-1.7,2.3l-11.2-63.2c1.1-.7,1.9-1.5,2.5-2.3,1.1-1.4,1.2-2.5,1-3.3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m989.5,133.44c.1.3,0,.6,0,.9-.7-.2-1.4-.3-2.1-.5l-.4-2.1c.3-.1.6,0,.9,0,.4.1.8.2,1.3.3l.3,1.4Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m989.4,4.74c.1.8.1,1.9-.8,3.2-.6.8-1.4,1.6-2.5,2.3l-.9-4.9c-.2-1.2.6-2.3,1.7-2.5,1.2-.1,2.3.7,2.5,1.9h0Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m989.4,4.74h0c-.2-1.2-1.3-2-2.5-1.8s-1.9,1.3-1.7,2.5h0c-.7-.6-4-1.6-9.2-.6-5.2.9-8,2.9-8.4,3.7h0c-.2-1.2-1.3-1.9-2.5-1.7-1.1.2-1.9,1.2-1.8,2.3-.1-.8,0-1.9.8-3.1,1.7-2.4,6-4.5,11.1-5.4s9.9-.4,12.3,1.3c1.4.8,1.8,2,1.9,2.8h0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m983.7,100.34l5.6,31.7c-.4-.1-.9-.2-1.3-.3-.3-.1-.6-.1-.9,0l-5.1-28.9c.1,0,.2-.1.3-.1,1-.4,1.6-1.4,1.4-2.4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m987.4,133.84c.7.2,1.4.4,2.1.5-.2.8-.8,1.4-1.7,1.6h-.4c-.2,0-.3,0-.5-.1h-.3c-.5-.2-.8-.5-1.1-.9l-.1-.1-.1-.1c0-.1-.1-.2-.1-.3v-.3c0-.3,0-.6.1-.9.2-.8.9-1.4,1.7-1.5l.4,2.1Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m982,102.84l5.1,28.9c-.8.1-1.5.7-1.7,1.5-.1.3-.1.6-.1.9l-5.4-30.6c.7-.3,1.4-.5,2.1-.7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m986.9,135.84q0,.1,0,0s-.1,0-.2-.1q.1.1.2.1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m985.2,5.44l.9,4.9c-2.1,1.4-5.2,2.5-8.6,3.1-1.6.3-3.3.4-4.9.4-1.5,0-2.9-.1-4.2-.4l-.9-4.9h0c.7.6,4,1.6,9.2.7,5.3-1,8.1-3,8.5-3.8h0Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m985.6,134.84l.1.1c-.1,0-.1-.1-.1-.1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m985.5,134.64q0,.1.1.1-.1,0-.1-.1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m985.3,134.24v.2c.1-.1.1-.2,0-.2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m983.7,100.34c.1,1-.4,2-1.4,2.3-.1,0-.2.1-.3.1l-.4-2.1c-.7.2-1.4.5-2,.7l-.4-2.1c.6-.2,1.1-.4,1.7-.6,1.1-.4,2.3.2,2.7,1.3q0,.1.1.2v.2Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m983.7,100.14q0-.1-.1-.2c-.4-1.1-1.6-1.7-2.7-1.3-.6.2-1.2.4-1.7.6l-3-17.1c.8-.3,1.6-.6,2.4-.8,1-.3,1.6-1.4,1.4-2.4l3.7,21.2Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m981.6,100.64l.4,2.1c-.7.2-1.4.5-2,.7l-.4-2.1c.6-.2,1.3-.4,2-.7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m979.9,78.94c.2,1-.4,2-1.4,2.4-.8.3-1.6.6-2.4.8l-.8-4.3c.6-.2,1.1-.4,1.7-.6,1.1-.4,2.3.2,2.7,1.3.2.2.2.3.2.4h0Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m968.4,13.34l11.6,65.6c0-.1-.1-.2-.1-.3-.4-1.1-1.6-1.7-2.7-1.3-.6.2-1.1.4-1.7.6l-12.1-68.6c.3,2.1,2.3,3.4,5,4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m975.4,77.94l.8,4.3c-28.3,10.4-45.7,26-47.7,43v-.1h0v-.6q0-.1-.1-.2v-.1c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c0-.1-.1-.1-.1-.1l-.1-.1c-.4-.3-.8-.5-1.3-.5-.2,0-.4,0-.6.1q-.1,0-.2.1h-.1s-.1,0-.1.1c-.1,0-.2.1-.3.2-.1.1-.2.1-.2.2l-.1.1-.1.1-.1.1c-.1.1-.2.3-.2.5h0v.1c2-18.8,20.6-35.7,50.8-46.7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m967.5 8.54 0.9 4.9c-2.7-0.6-4.7-1.9-5.1-4.1v-0.2c-0.1-1.1 0.7-2.1 1.8-2.3s2.2 0.5 2.4 1.7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.5,125.04h0v.2h0v.2c0,.1,0,.2-.1.3v.1c-.3.8-1.1,1.3-2,1.3h-.2c-1.1-.1-2-1.2-1.9-2.3v-.1c0-.1,0-.2.1-.4h0c.1-.2.1-.3.2-.5l.1-.1.1-.1.1-.1.2-.2c.1-.1.2-.1.3-.2,0,0,.1,0,.1-.1h.1q.1,0,.2-.1c.3-.1.6-.1.9-.1.4.1.8.2,1.1.4l.1.1.1.1.1.1c0,.1.1.1.1.2s.1.1.1.2v.1q0,.1.1.2v.4q.1.3.1.4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.5,124.64v-.1c-.1,0-.1.1,0,.1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.4,124.34q0-.1-.1-.2c.1.1.1.2.1.2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.3,124.14c0-.1-.1-.1-.1-.2,0,0,0,.1.1.2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.2,123.94c0-.1-.1-.1-.1-.2,0,.1.1.1.1.2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m928.1,123.74l-.1-.1s0,.1.1.1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m927.8,123.44c.1,0,.1.1.1.1l-.1-.1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m926.4,127.14c.9,0,1.6-.5,2-1.3-1.2,3.4-2.3,6.9-3.4,10.4-.6-2.5-.9-5.1-.9-7.7,0-1.3.1-2.5.2-3.7-.1,1.1.7,2.2,1.9,2.3,0,0,.1,0,.2,0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m927.8,123.44l-.1-.1c0,.1.1.1.1.1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m927.7,123.34c-.3-.2-.7-.4-1.1-.4-.3,0-.6,0-.9.1.2-.1.4-.1.6-.1.6,0,1,.1,1.4.4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m925.8,122.94q-.1,0-.2.1s.1,0,.2-.1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m925.5,123.04s-.1,0-.1.1c0,0,.1,0,.1-.1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m925.1,123.34c-.1.1-.2.1-.2.2,0-.1.1-.2.2-.2"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m924.7,123.64l-.1.1q.1,0,.1-.1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m924.6,123.74l-.1.1q.1,0,.1-.1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m924.3,124.54v-.1c0,.1-.1.2-.1.4v.1-.1c0-.1.1-.2.1-.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m857.7 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m874.1,148.54c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m890.4 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.7 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m923.1 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m939.4 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m955.8 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m972.1 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m988.5,148.54c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1004.8 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1021.1 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1037.5 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1053.8 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1070.2,148.54c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1086.5 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1102.8 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.2 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.5 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1151.9 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1168.2 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1184.6,148.54c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1200.9 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1217.2,148.54c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1233.6 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1249.9 148.54c0 4.6-0.9 8.4-2 8.4s-2-3.8-2-8.4 0.9-8.4 2-8.4 2 3.8 2 8.4"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m866.7,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m883.1,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m899.4,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m915.8,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m932.1,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m948.4,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m964.8,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m981.1,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m997.5,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1013.8,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1030.2,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1046.5,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1062.8,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1079.2,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1095.5,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.9,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1128.2,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1144.5,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1160.9,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1177.2,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1193.6,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1209.9,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1226.3,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1242.6,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1258.9,169.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m857.7,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m874.1,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m890.4,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.7,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m923.1,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m939.4,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m955.8,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m972.1,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m988.5,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1004.8,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1021.1,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1037.5,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1053.8,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1070.2,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1086.5,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1102.8,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.2,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.5,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1151.9,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1168.2,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1184.6,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1200.9,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1217.2,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1233.6,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1249.9,189.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m866.7,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m883.1,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m899.4,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m915.8,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m932.1,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m948.4,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m964.8,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m981.1,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m997.5,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1013.8,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1030.2,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1046.5,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1062.8,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1079.2,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1095.5,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.9,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1128.2,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1144.5,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1160.9,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1177.2,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1193.6,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1209.9,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1226.3,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1242.6,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1258.9,210.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m857.7,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m874.1,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m890.4,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.7,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m923.1,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m939.4,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m955.8,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m972.1,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1037.5,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1053.8,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1070.2,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.5,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1151.9,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1168.2,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1184.6,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1200.9,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1217.2,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1233.6,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1249.9,230.64c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m866.7,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m883.1,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m899.4,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m915.8,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,.1,2,3.8,2,8.4"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m932.1,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m948.4,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m964.8,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m981.1,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m997.5,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.9,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,.1,2,3.8,2,8.4"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1128.2,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1144.5,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1160.9,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1177.2,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1193.6,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1209.9,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1226.3,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,.1,2,3.8,2,8.4"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1242.6,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1.1.1,2,3.8,2,8.4"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1258.9,251.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m857.7,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m874.1,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m890.4,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.7,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m923.1,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m939.4,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m955.8,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m972.1,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m988.5,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1004.8,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1102.8,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.2,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.5,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1151.9,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1168.2,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1184.6,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.7,2,8.4"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1200.9,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1217.2,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1233.6,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1249.9,271.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.7,2,8.4"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m866.7,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m883.1,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m899.4,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m915.8,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m932.1,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m948.4,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m964.8,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m981.1,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m997.5,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1013.8,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1095.5,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1111.9,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1128.2,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1144.5,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1160.9,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1177.2,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1193.6,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1209.9,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1226.3,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1242.6,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1258.9,292.84c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m857.7,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m874.1,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m890.4,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.7,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m923.1,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m939.4,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m955.8,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m972.1,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m988.5,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1004.8,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1021.1,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1037.5,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1053.8,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1086.5,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1102.8,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1119.2,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1135.5,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1151.9,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1168.2,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1184.6,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4c1,0,2,3.8,2,8.4"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1200.9,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1217.2,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1233.6,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1249.9,312.74c0,4.6-.9,8.4-2,8.4s-2-3.8-2-8.4.9-8.4,2-8.4,2,3.8,2,8.4"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1174.6,124.34c0-.1-.1-.1-.1-.2-2.5-18.5-21-35.3-51-46.1l12.1-68.5v-.4c.1-.8,0-1.9-.9-3.1-1.7-2.4-6-4.5-11.1-5.4s-9.9-.4-12.3,1.3c-1.3.9-1.8,2-1.9,2.8h0l-11.7,66.1c-15.4-3.2-31.6-4.8-48.5-4.8s-33,1.6-48.3,4.8l-11.6-66v-.1c-.1-.8-.6-1.9-1.9-2.8-2.4-1.7-7.1-2.2-12.3-1.3-5.1.9-9.4,3-11.1,5.4-.9,1.2-.9,2.3-.8,3.1v.2h0l12.1,68.6c-30.3,11-48.8,27.9-51.2,46.6-8.4,23.9-13.1,49.8-13.3,73-.2,29.7,6.8,54.7,20.6,74.2,22.4,31.8,62.1,47.9,117.8,47.9h.1c55.7,0,95.4-16.1,117.8-47.9,13.8-19.6,20.8-44.6,20.6-74.3.1-23.2-4.7-49.2-13.1-73.1m-51.7-119.6c5.2.9,8,2.9,8.4,3.7-.7.6-4,1.6-9.2.7s-8-2.9-8.4-3.8c.7-.5,4-1.5,9.2-.6m-21.3,69l11.2-63.5c2.1,1.4,5.2,2.5,8.6,3.1,1.7.3,3.4.4,4.9.4s3-.1,4.2-.4l-11.6,65.6v.1l-3.8,21.3-5.6,31.7c-2.9.7-6.2,1-9.6,1-3,0-6-.3-8.7-.8l6.5-36.9,3.9-21.6Zm-52.2-3.5c16.6,0,32.6,1.6,47.7,4.7l-3.1,17.5c-13.8-2.6-29.1-3.9-44.6-3.9s-30.8,1.3-44.5,3.9l-3.1-17.5c15-3.1,31-4.7,47.6-4.7M975.9,4.74c5.2-.9,8.5,0,9.2.6-.4.8-3.2,2.8-8.4,3.8-5.2.9-8.5,0-9.2-.7.4-.7,3.2-2.7,8.4-3.7m-7.6,8.6c1.3.3,2.7.4,4.2.4,1.6,0,3.3-.2,4.9-.4,3.4-.6,6.4-1.7,8.6-3.1l11.2,63.2v.3l3.8,21.4v.3l6.5,36.9c-2.7.5-5.6.8-8.7.8-3.4,0-6.8-.4-9.6-1l-5.6-31.7v-.2l-3.7-21.2h0l-11.6-65.7Zm-39.9,112h0q0-.1,0,0v-.1c2-17,19.4-32.6,47.7-43l3,17.1c-20.7,7.5-32.1,17.9-32.1,29.3,0,22.4,45,40,102.4,40s102.4-17.6,102.4-40c0-11.4-11.4-21.7-32-29.2l3-17.1c28.3,10.4,45.6,26.1,47.6,43.1.1,1.1.2,2.1.2,3.2,0,32.1-54.3,58.3-121.1,58.3-15.1,0-29.8-1.3-43.7-4-16.3-3.1-31.4-7.9-43.5-14-21.9-11-33.9-25.3-33.9-40.3-.2-1.2-.1-2.3,0-3.3m235.4,144c-21.6,30.6-60.1,46.1-114.4,46.1h-.1c-54.3,0-92.8-15.5-114.4-46.1-13.3-18.8-20-43-19.8-71.8.1-19.4,3.5-40.9,9.7-61.3,3.3,13.8,15.6,26.5,35.3,36.4,12.5,6.3,28,11.3,44.7,14.4,14.2,2.7,29.2,4,44.5,4,33.2,0,64.5-6.4,88.1-17.9,20.5-10,33.1-23,36.4-37.2,6.2,20.5,9.6,42,9.7,61.5.3,28.9-6.4,53-19.7,71.9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1112.9,227.94c-.4-.1-10.6-1.2-22.2,1.3-6.8,1.4-12.7,3.8-17.6,7h-.2c-1.5,1-3,2-4.4,3.2-1,.8-1.6,2-1.6,3.4v1.1c0,10.8,6.4,19.7,14.4,19.7s14.4-8.8,14.4-19.7c0-4-.8-7.8-2.4-11,10.3-1.9,19.2-.9,19.3-.9,1.2.1,2.2-.7,2.4-1.9-.1-1-.9-2.1-2.1-2.2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1049.7,267.74h0c-10.5,0-23.9,5-29.6,14.5-1.7,2.8-2.1,5.5-1,7.4,1.5,3,4.9,3.8,9.6,3.8,2.3,0,5-.2,8-.4,1.9-.1,3.8-.3,5.8-.4.2.6.6,1.1,1.1,1.6.6.5,1.4.9,2.5,1.1,1.4.2,2.7.1,3.8,0,.4,0,.8-.1,1.2-.1,1.3-.1,2.2.2,2.6.6.3.4.6,1,.6,2,0,.4.1.8.1,1.2,0,.8.1,1.7.2,2.6.4,1.9,1.4,2.9,2.1,3.4,1.6,1,3.8.8,5.4-.6,1-.9,1.6-2.1,2-3.8.1-.4.2-.8.2-1.3,0-.3.1-.5.1-.8.3.9.3,1.9.4,3,.1,1.4.2,3.1.8,4.6.2.5.5,1.2,1.1,1.8.7.6,1.5,1,2.5,1.1h.5c1.7,0,3.3-.9,4.4-2.4,1-1.4,1.4-2.9,1.6-4.2.6-3.4.5-6.9.3-9.8,1.9-.6,3.2-1.6,3.9-3.2,1-1.9.7-4.5-1-7.4-4-7-15.5-14.3-29.2-14.3m22,34.1c-.1.8-.4,1.7-.8,2.4-.3.4-.7.7-1,.7,0,0-.1-.1-.1-.3-.4-.9-.4-2.1-.5-3.3-.1-1.5-.2-3.2-.8-4.8-.4-1-1-1.8-1.8-2.4-.7-.5-1.5-.7-2.2-.7-.6,0-1.2.1-1.7.4-1.3.7-1.8,2.1-1.9,2.6-.2.7-.3,1.4-.5,2.1-.1.4-.1.7-.2,1.1-.2.8-.4,1.3-.7,1.6-.1.1-.2.1-.3.1-.1-.1-.1-.3-.2-.6-.1-.6-.1-1.2-.2-1.9,0-.5,0-.9-.1-1.4-.2-2-.8-3.4-1.8-4.5-1.4-1.4-3.4-2.1-5.9-1.9-.5,0-1,.1-1.4.1-1,.1-1.9.2-2.7,0-.2,0-.4-.1-.4-.1v-.1h0v-.1c0-.1.1-.2.2-.3h0c.4-.3,1-.3,2-.4h.8c1.6-.1,3.3-.1,4.9-.2,1.7-.1,3.4-.1,5.2-.2,3.2-.2,6.6-.2,9.8.4,1.9.4,2.4.9,2.5,1.2,0,.1.1.2.1.3.1.3.1.7.1,1,.1,3.5.2,6.4-.4,9.2m4.7-14.2s0,.1-.1.1c-.2.4-.6.7-1.2.9-1.5-2.1-4.1-2.6-5.1-2.8-3.7-.7-7.4-.6-10.8-.5-1.7.1-3.4.2-5.1.2-1.7.1-3.3.1-5,.2h-.7c-1.4,0-3.2.1-4.8,1.4-.4.3-.7.7-.9,1.1-2.3.1-4.4.3-6.5.4-6.1.4-12.5.9-13.4-1.1v-.1c-.1-.2-.2-1.3.9-3.2,3-5,12.3-12.4,25.8-12.4h.1c13.5,0,22.8,7.4,25.8,12.4,1.2,2.2,1.1,3.2,1,3.4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1047.8,265.14c.4.7,1.1,1.1,1.8,1.1.8,0,1.5-.4,1.8-1.1l7.1-12.3c.4-.7.4-1.5,0-2.1-.4-.7-1.1-1.1-1.9-1.1h-14.2c-.8,0-1.5.4-1.8,1.1-.4.7-.4,1.5,0,2.1l7.2,12.3Zm5.2-11.2l-3.4,5.9-3.4-5.9h6.8Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1032,244.04v-1.1c0-1.3-.6-2.5-1.6-3.4-1.4-1.2-3-2.4-4.6-3.3l-.1-.1c-4.8-3.2-10.7-5.5-17.5-6.9-11.6-2.4-21.8-1.3-22.3-1.3-1.2.1-2,1.2-1.9,2.4.1,1.2,1.2,2,2.4,1.9.1,0,9-1,19.3.9-1.6,3.2-2.4,7-2.4,11,0,10.8,6.4,19.7,14.4,19.7,7.9-.1,14.3-8.9,14.3-19.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadcocoLogo1);
export default __webpack_public_path__ + "static/media/madcoco_logo_1.0cc88e33189ea208b1630032445de03d.svg";
export { ForwardRef as ReactComponent };